import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from 'reducers/rootReducer'
import coMiddleware from 'redux-co'

export default function configureStore (initialState) {
  let store

  if (window.devToolsExtension) {
    store = createStore(rootReducer, initialState,
      compose(
        applyMiddleware(coMiddleware),
        window.devToolsExtension()
      )
    )
  } else {
    store = createStore(rootReducer, initialState, applyMiddleware(coMiddleware))
  }

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/rootReducer', () => {
      const nextReducer = require('../reducers/rootReducer').default
      store.replaceReducer(nextReducer)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js